/* global define:true */


/** Name:  Tray height helper */

define(['squid/index', 'jquery'], function (squid, $) {
    squid.module('xo-tray-height.directive', ['squid']).directive('xoTrayHeight', function ($timeout) {
        return {
            restrict: 'A',
            link: function link($scope, element, attrs) {
                function calculate() {
                    var height;
                    var headerHeight;
                    var mainHeight;
                    var trayMinheight = 400;
                    var asideContentHeight;
                    var $aside = $(element).parents('aside:visible');
                    var $asideContent = $aside.find('.asideContent');

                    if (!$aside || !$asideContent) {
                        return;
                    }

                    // Updates the tray height to the section height
                    headerHeight = $aside.find('.header').outerHeight(true);
                    mainHeight = $('#main').outerHeight(true);

                    height = mainHeight - headerHeight;
                    asideContentHeight = $asideContent.outerHeight(true);
                    if ($scope.miniBrowser) {
                        $aside.find('.aside').css('height', '534px');
                        var minHeight = 534 - headerHeight;
                        $asideContent.css('height', minHeight);
                    } else if (asideContentHeight > height) {
                        $asideContent.css('height', height);
                        $aside.find('aside:visible').addClass('hasScroll');
                    } else {
                        height = height > trayMinheight ? height : trayMinheight;
                        $asideContent.css('height', height);
                        $aside.removeClass('hasScroll');
                    }
                }

                $timeout(calculate, 1);

                $scope.$on('SidebarError', function () {
                    calculate();
                });
            }
        };
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-tray-height/dist/directive.js
 ** module id = 258
 ** module chunks = 1
 **/